/* stylelint-disable selector-max-compound-selectors, max-nesting-depth */

:host {
    border-bottom: 1px solid currentColor;
    display: block;
    padding: 32px 0;

    > .location-date {
        @include typo-ws-paragraph;

        margin: 0;
    }

    .link {
        margin: 8px 0 0;
    }

    ::slotted(a) {
        text-decoration: none;
    }
}

@include mq-1 {
    :host {
        padding: 24px 0;
    }
}
